import type { TranslationInterface } from '.';

export const FilipinoLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Magsulat ng mensahe...',
  your_issue_has_been_resolved: 'Nalutas na ang iyong isyu!',
  new_conversation: 'Bagong usapan',
  welcome_screen_title: 'Maligayang pagdating sa aming support chat',
  welcome_screen_description:
    'Narito kami upang tumulong! Magsimula ng usapan at babalikan ka namin sa lalong madaling panahon.',
  your_name_placeholder: 'Iyong pangalan',
  your_email_placeholder: 'Iyong email address',
  start_chat_button: 'Makipag-usap sa support',
  start_chat_button_loading: 'Kumokonekta...',
  i_need_more_help: 'Kailangan ko pa ng tulong',
  this_was_helpful: 'Nakatulong ito',
  optional: 'Opsyonal',
  no_conversations_yet: 'Wala pang mga usapan',
  back_to_conversations: 'Bumalik sa mga usapan',
  closed_conversations: 'Mga saradong usapan',
  csat_title: 'Kumusta ang iyong usapan?',
  csat_submitted_title: 'Ni-rate mo ang usapan bilang',
  csat_feedback_placeholder: 'Sabihin pa sa amin... (opsyonal)',
  follow_up_placeholder: 'Magpatuloy…',
  companion_layout_label: 'Ayos',
  companion_layout_floating: 'Lumulutang',
  companion_layout_sidebar: 'Sidebar',
  companion_layout_fullscreen: 'Buong screen',
  companion_close: 'Isara',
  companion_history: 'Kasaysayan ng mga pag-uusap',
  companion_expand_chat: 'Palawakin ang chat',
  companion_sidebar_dock_label: 'Dock',
  companion_sidebar_side_label: 'Gilid',
  companion_sidebar_left: 'Kaliwa',
  companion_sidebar_right: 'Kanan',
  companion_resize_chat: 'Baguhin ang laki ng chat',
  scroll_to_bottom: 'Mag-scroll sa ibaba',
  thinking: 'Nag-iisip…',
  running: 'Isinasagawa…',
  steps: 'mga hakbang',
  step_arguments: 'Mga argumento',
  step_result: 'Resulta',
  attach_files:
    'Mag-attach ng mga larawan, video, PDF, o spreadsheet (maximum na laki 25 MB)',
  mark_page_active:
    'Mag-click ng kahit ano sa page para markahan ito — Esc para kanselahin',
  mark_page: 'Markahan ang isang bagay sa page para magtanong tungkol dito',
  stop_response: 'Ihinto ang sagot',
  copy_reply: 'Kopyahin ang sagot',
  mentions_empty: 'Walang tugma',
  copied: 'Nakopya',
  send_message: 'Ipadala ang mensahe',
  upload_failed: 'Hindi na-upload: {error}',
  remove_attachment: 'Alisin ang attachment',
  json_no_items: 'Walang mga item',
  json_no_data: 'Walang data',
  json_no_chart_data: 'Walang data para sa chart',
  json_unsupported: 'Hindi suportado: {type}',
  json_see_less: 'Tumingin ng mas kaunti',
  json_phone_agent: 'Phone agent',
  json_phone_agent_test: 'Subukan sa web',
  page_context_remove: 'Alisin ang konteksto ng page',
  json_see_more: 'Tumingin pa ng {count}',
  queued_label: '{count} Nakapila',
  remove_queued_message: 'Alisin ang mensahe sa pila',
  send_queued_now: 'Ipadala na ang mga mensahe sa pila',
  turn_failed_message: 'Nagkaproblema at hindi dumating ang sagot.',
  turn_failed_retry: 'Subukan muli',
  page_mark_hint: 'Mag-click ng kahit ano para markahan ito',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Kahon',
  page_mark_shape_circle: 'Bilog',
  page_mark_shape_arrow: 'Palaso',
  page_mark_shape_bracket: 'Bracket',
  page_mark_shape_underline: 'Salungguhit',
  page_mark_shape_highlight: 'Highlight',
  page_mark_shape_strike_through: 'Guhit sa gitna',
  page_mark_shape_crossed_off: 'Ekis',
  page_mark_shape_aria: 'Hugis ng marka: {shape}',
  page_mark_note_placeholder: 'Magdagdag ng tala… (Enter para i-attach)',
  page_mark_attach: 'I-attach ang marka',
  page_mark_remove: 'Alisin ang {label}',
  page_mark_region: 'Minarkahang bahagi',
  page_mark_default_message: 'Ano ito?',
  file_rejected: 'Hindi suportado ang uri ng file o masyadong malaki ang file.',
  dictate: 'Mag-dictate',
  stop_dictation: 'Ihinto ang dictation',
  dictation_mic_blocked: 'Payagan ang access sa mikropono para mag-dictate',
  dictation_unavailable: 'Hindi available ang dictation ngayon',
  questions_back: 'Bumalik',
  questions_next: 'Susunod',
  questions_send: 'Ipadala',
  questions_type_answer: 'Ako na ang magta-type',
  questions_answer_placeholder: 'I-type ang iyong sagot…',
  close_conversation_title: 'Isara ang usapan',
  close_conversation_description:
    'Sigurado ka bang gusto mong isara ang usapang ito?',
  close_conversation_cancel: 'Hindi',
  close_conversation_confirm: 'Oo',
  dialog_close: 'Isara',
  zoom_in: 'Palakihin',
  zoom_out: 'Paliitin',
  reset_zoom: 'I-reset ang zoom',
  support_chat_aria_label: 'Chat ng suporta',
};
